import React, { ChangeEvent, CSSProperties, FC, useState } from 'react';
import { ModalContainer } from './ModalContainer';
import { COLORS } from '../../utils/Colors';
import { Separator } from '../Separator';
import { Input } from '../Input';
import { Button } from '../Button';
import { PressableText } from '../PressableText';
import { NFCIcon } from '../../../assets/icons/NFCIcon';
import { API } from '../../utils/API';
import { useUIContext } from '../../context/UIContext';
import { useMainContext } from '../../context/MainContext';

interface AddSmartCardModalProps {
  onCancel: () => void;
}

export const AddSmartCardModal: FC<AddSmartCardModalProps> = ({ onCancel }) => {
  const styles = {
    iconContainer: {
      width: 100,
      height: 100,
      background: COLORS.BLUE_OPACITY,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 50,
    } as CSSProperties,
    body: {
      textAlign: 'center',
    } as CSSProperties,
  };

  const { loader, toast } = useUIContext();
  const { profile, fetchProfile } = useMainContext();

  const [cardID, setCardID] = useState<string>(profile?.smart_card_nfc_id ?? '');

  const handleCardChange = (event: ChangeEvent<HTMLInputElement>) => setCardID(event.target.value);

  const handleSave = () => {
    if (profile) {
      if (cardID === profile.smart_card_nfc_id) {
        onCancel();
        return;
      }

      loader.showLoader();
      if (cardID === '' && profile.smart_card_nfc_id !== '') {
        API.Users.deleteSmartCard(profile.smart_card_nfc_id)
          .then(() => {
            onCancel();
          })
          .catch((deleteError) => toast.showToast(deleteError.message, 'ERROR'))
          .finally(() => {
            fetchProfile().finally(() => undefined);
          });
        return;
      }

      API.Users.addSmartCard(cardID)
        .then(() => {
          onCancel();
        })
        .catch((deleteError) => toast.showToast(deleteError.message, 'ERROR'))
        .finally(() => {
          fetchProfile().finally(() => undefined);
        });
    }
  };

  return (
    <ModalContainer>
      <div style={styles.iconContainer}>
        <NFCIcon width={60} height={60} color={COLORS.BLUE} />
      </div>
      <Separator size="M" />
      <Input
        onError={false}
        onChange={handleCardChange}
        errorMessage=""
        placeholder="Smart card ID"
        defValue={cardID}
      />
      <Separator size="S" />
      <Button onClick={handleSave} width="100%" type="PRIMARY" title="Save changes" />
      <Separator size="S" />
      <PressableText onClick={onCancel} width="100%" title="Cancel" textAlign="center" />
    </ModalContainer>
  );
};
